// Stub replacing @latticexyz/store-sync/react
export function useSync() {
  return {
    data: {
      waitForTransaction: async (_tx: unknown) => {},
    },
  };
}

// No-op SyncProvider passthrough (not used after index.tsx rewrite, but avoids import errors)
export function SyncProvider({ children }: { children: React.ReactNode }) {
  return children;
}

import React from "react";
